import {
  Alignment,
  Button,
  Classes,
  Dialog,
  HTMLSelect,
  InputGroup,
  Switch,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import {
  ICalc,
  IContestacaoProduto,
  IEmpresa,
  IProdutos,
  IResultadoItemProdutos,
  newIProdutos,
} from "../../model";
import { CalcStore } from "../../stores/calculo/CalcStore";
import { ResultadoStore } from "../../stores/resultados/ResultadoStore";
import { toast } from "react-toastify";
import CurrencyInput from "../utils/CurrencyInput";
import { FormGroup } from "@blueprintjs/core";
import { getMomentFormatter } from "../../utils";
import { DateInput } from "@blueprintjs/datetime";
import MomentLocaleUtils from "react-day-picker/moment";
import { CalcRSStore } from "../../stores/calculo-rs/CalcRSStore";
import { AppStore } from "../../stores/AppStore";
import { CalcSelect, filterCalcs, renderCalcs } from "../utils/CalcSelect";
import InfoModal from "../info-modal/InfoModal";
import { AppIcon } from "../utils/AppIcon";
const numeral = require("numeral");

interface ContestarProdutoProps {
  item: IResultadoItemProdutos;
  modelo: string;
  estado: string;
  onClose: () => void;
  onCancel: () => void;
  empresaSelecionada: IEmpresa;
}

interface ContestarProdutoState {
}

@observer
export class ContestarProduto
  extends React.Component<ContestarProdutoProps, ContestarProdutoState> {
  obs = observable({
    contestacao: {} as IContestacaoProduto,
    produto: newIProdutos() as IProdutos,
    memoria_salvar: false as boolean,
    retroativas: true as boolean,
    aplicar_retencao: false as boolean,
    isDevolucao: false,
    calc_selecionado: null,
    calc_devolucao_selecionado: null,
    cnpj_memoria: true as boolean,
    open_ajuda: false as boolean
  })

  constructor(props: any) {
    super(props);
  }

  async componentDidMount(): Promise<void> {

    if (this.props.estado == "RS") {

      await CalcRSStore.load();

    } else {

      await CalcStore.load();

    }

    this.obs.produto = newIProdutos();

    this.obs.contestacao = observable({
      nota_item_ids: [this.props.item._id],
      valor_contestado: (parseFloat(this.props.item.valor_contestacao_icms) || 0),
      motivo: this.props.item.motivo_contestacao_icms || "",
      contestacao_calc_id: null,
      entrada_saida: this.props.item.entrada_saida,
      modelo: "nf-e",
      produto: this.props.item.produtos,
      contestacao_data: null,
    });

  }

  handleConfirm = async () => {

    if (!this.obs.calc_selecionado || !this.obs.calc_selecionado._id) {
      toast.warning('Por favor, selecione um cálculo.', {});
      return;
    } 

    if (!this.obs.produto.id) {
      toast.warning('Por favor, selecione um produto válido', {});
      return
    }

    if (!this.obs.contestacao.motivo) {
      toast.warning('Por favor, preencha o motivo da contestação!', {});
      return
    }

    this.obs.contestacao.produto = this.obs.produto;

    let devolucao = false

    if (this.obs.aplicar_retencao) {

      if (!this.obs.calc_devolucao_selecionado._id) {
        toast.warning('Por favor, selecione um cálculo para a retenção.', {});
        return;
      }

      this.obs.contestacao.contestacao_calc_id_devolucao = this.obs.calc_devolucao_selecionado._id
      this.obs.contestacao.contestacao_calc_id = this.obs.calc_selecionado._id

      devolucao = true

    } else {

      delete this.obs.contestacao.contestacao_calc_id_devolucao
      this.obs.contestacao.contestacao_calc_id = this.obs.calc_selecionado._id

      devolucao = false

    }

    let cnpj = (this.props.item.entrada_saida == "entrada") ? this.props.item.cnpj_destino : this.props.item.cnpj_origem

    await ResultadoStore.create_contestacao_task(this.obs.contestacao, this.obs.memoria_salvar, this.props.estado.toLowerCase(), devolucao, cnpj, null, null, this.obs.cnpj_memoria)

    ResultadoStore.consulta_resultados_calculo()

    this.props.onClose();

  }

  getProduto(id: string) {
    if (Array.isArray(this.obs.contestacao.produto)) {
      for (let i: number = 0; i < this.obs.contestacao.produto.length; i += 1) {
        if (this.obs.contestacao.produto[i].id == id) {
          this.obs.produto = this.obs.contestacao.produto[i];

          return;
        }
      }
    } else {
      this.obs.produto = this.obs.contestacao.produto;

      return;
    }

    this.obs.produto = newIProdutos();
  }

  handleFilterCalcs(calcs: any, tmp_tipo: string, tmp_modelo: string) {

    let calc_options = []

    calc_options = calcs?.map((calc: ICalc) => {

      if (calc[tmp_tipo] == true && calc[tmp_modelo] == true) {

        return calc

      }

      return null

    }).filter(option => option !== null);

    return calc_options

  }

  handleValidDevolucao() {
    let calcOptions: any = []

    if (ResultadoStore.obs.empresaContestar.uf == "RS") {

      calcOptions = CalcRSStore.validForDate()?.find(obj => obj._id == this.obs.calc_selecionado._id)

      this.obs.isDevolucao = calcOptions?.devolucao ? calcOptions.devolucao : false

    } else {

      calcOptions = CalcStore.validForDate()?.find(obj => obj._id == this.obs.calc_selecionado._id)

      this.obs.isDevolucao = calcOptions?.devolucao ? calcOptions.devolucao : false

    }

  }

  render() {
    let tmp_tipo = this.props.item.entrada_saida
    let tmp_modelo = this.props.modelo.toLowerCase().replace("-", "");

    let calcOptions: any = []
    let calcOptionsRetro: any = []
    let calcOptionsRetencao: any = []
    let produtoOptions: any = []

    let dayPickerProps = {
      localeUtils: MomentLocaleUtils,
      locale: "pt-br",
    };

    if (this.props.estado == "RS") {
      calcOptions = this.handleFilterCalcs(CalcRSStore.validForDate(), tmp_tipo, tmp_modelo)
      calcOptionsRetro = this.handleFilterCalcs(CalcRSStore.validForDateRetro(), tmp_tipo, tmp_modelo)

    } else {
      calcOptions = this.handleFilterCalcs(CalcStore.validForDate(), tmp_tipo, tmp_modelo)
      calcOptionsRetro = this.handleFilterCalcs(CalcStore.validForDateRetro(), tmp_tipo, tmp_modelo)
    }

    if (this.props.item.produtos) {
      produtoOptions = this.props.item.produtos?.map(el => {
        return (
          <option key={el.id} value={el.id} title={`Cest: ${el.cest} - Aliquota: ${el.aliquota} - Descrição ${el.descricao}`}>
            {`Cest: ${el.cest} - Aliquota: ${el.aliquota} - Descrição ${el.descricao.substring(0, 80)}...`}
          </option>
        );
      });

      produtoOptions.push(<option disabled value="" key={Math.random() * 99}>Selecione o produto correto...</option>,);
      produtoOptions.reverse();
    }

    calcOptionsRetencao = CalcStore.validForDate()?.map((calc: ICalc) => {

      if (calc["saida"] == true && calc[tmp_modelo] == true) {

        return calc

      }

      return null

    }).filter(option => option !== null);

    let calcText = !this.obs.calc_selecionado?.nome ? "Selecione o Cálculo" : `${this.obs.calc_selecionado.nome.length >= 100 ? this.obs.calc_selecionado.nome.substring(0, 100) + "..." : this.obs.calc_selecionado.nome}`
    let devolucaoText = !this.obs.calc_devolucao_selecionado?.nome ? "Selecione o Cálculo" : `${this.obs.calc_devolucao_selecionado.nome.length >= 120 ? this.obs.calc_devolucao_selecionado.nome.substring(0, 120) + "..." : this.obs.calc_devolucao_selecionado.nome}`

    return (<>

      <Dialog
        isOpen={true}
        onClose={this.props.onClose}
        className="modal-contestacao"
      >
        <div className={Classes.DIALOG_HEADER}>
          <div style={{ display: "flex", width: "100%" }}>
            <h2 className="title-no-bottom">Contestar Cálculo</h2>
            {this.obs.isDevolucao && tmp_tipo == "entrada" && AppStore.obs1.selectedEmpresa.simples_nacional && (tmp_modelo.toLowerCase() == "nfe" || tmp_modelo.toLowerCase() == "nfce") &&
              <Switch
                label={"Aplicar retenção na saída?"}
                checked={this.obs.aplicar_retencao}
                onChange={(e: any) => this.obs.aplicar_retencao = e.target.checked}
                style={{ marginTop: 12, marginLeft: "auto", fontSize: 12, fontWeight: 600 }}
              />
            }
          </div>
        </div>
        <div className={Classes.DIALOG_BODY}>

          <div className="item-dialog-grid" style={{ gridTemplateColumns: "1fr 1fr 1fr", marginBottom: 24 }}>
            <div className="detalhamento-field">
              <span className="detalhamento-field-label">Valor Produto</span>
              <span className="detalhamento-field-value" style={{ fontSize: 15, fontWeight: 700 }}>
                {numeral(this.props.item.valor_produto).format("$ 0,0.00")}
              </span>
            </div>
            <div className="detalhamento-field">
              <span className="detalhamento-field-label">ICMS Calculado</span>
              <span className="detalhamento-field-value" style={{ fontSize: 15, fontWeight: 700 }}>
                {numeral(this.props.item.valor_icms_ant).format("$ 0,0.00")}
              </span>
            </div>
            <div className="detalhamento-field">
              <span className="detalhamento-field-label">Valor a Pagar</span>
              <span className="detalhamento-field-value valor-pagar" style={{ fontSize: 15 }}>
                {numeral((parseFloat(this.props.item.valor_icms_ant) || 0) - this.obs.contestacao.valor_contestado).format("$ 0,0.00")}
              </span>
            </div>
          </div>

          <div className="contestar-form">
            <div className="contestar-row">
              <FormGroup
                label={<>Utilizar cálculo <span className="contestar-required">*</span></>}
                className="empresaSelect calcSelectProduto contestar-field-grow"
              >
                <CalcSelect
                  items={this.obs.retroativas ? calcOptions : calcOptionsRetro}
                  itemRenderer={renderCalcs}
                  itemPredicate={filterCalcs}
                  onItemSelect={(e: ICalc) => {
                    this.obs.calc_selecionado = e
                    this.handleValidDevolucao()
                  }}
                  inputProps={{ placeholder: "Filtrar um Cálculo" }}
                  matchTargetWidth
                >
                  <Button text={calcText} rightIcon="double-caret-vertical" alignText={Alignment.LEFT} />
                </CalcSelect>
              </FormGroup>
              <FormGroup label={"\u200B"} style={{ width: 152 }}>
                <Switch
                  label={this.obs.retroativas ? "Cálculo Vigentes" : "Cálculos Retroativos"}
                  checked={this.obs.retroativas}
                  onChange={(e: any) => this.obs.retroativas = e.target.checked}
                  style={{ marginBottom: 0, marginTop: 12, flexShrink: 0 }}
                />
              </FormGroup>
            </div>

            {this.obs.aplicar_retencao && (
              <div className="contestar-row">
                <FormGroup label={<>Cálculo da retenção <span className="contestar-required">*</span></>} className="empresaSelect calcSelect contestar-field-grow">
                  <CalcSelect
                    items={calcOptionsRetencao}
                    itemRenderer={renderCalcs}
                    itemPredicate={filterCalcs}
                    onItemSelect={(e: ICalc) => this.obs.calc_devolucao_selecionado = e}
                    inputProps={{ placeholder: "Filtrar um Cálculo" }}
                    matchTargetWidth
                  >
                    <Button text={devolucaoText} rightIcon="double-caret-vertical" alignText={Alignment.LEFT} />
                  </CalcSelect>
                </FormGroup>
              </div>
            )}

            <div className="contestar-row">
              <FormGroup label={<>Produto <span className="contestar-required">*</span></>} className="contestar-field-grow">
                <HTMLSelect
                  onChange={(e: any) => this.getProduto(e.target.value)}
                  value={this.obs.produto.id ?? ""}
                  fill
                >
                  {produtoOptions}
                </HTMLSelect>
              </FormGroup>
            </div>

            <div className="contestar-row">
              <FormGroup label="Valor Contestado" className="contestar-field-grow">
                <CurrencyInput
                  allowNegative
                  showIcon={false}
                  value={this.obs.contestacao.valor_contestado}
                  onChange={val => this.obs.contestacao.valor_contestado = val}
                />
              </FormGroup>
              <FormGroup label="Alterar data" style={{ flex: "0 0 180px" }}>
                <DateInput
                  {...getMomentFormatter("DD/MM/YYYY")}
                  locale="pt-br"
                  dayPickerProps={dayPickerProps}
                  value={this.obs.contestacao.contestacao_data ? new Date(this.obs.contestacao.contestacao_data) : null}
                  onChange={val => this.obs.contestacao.contestacao_data = val}
                  placeholder="DD/MM/AAAA"
                  canClearSelection
                />
              </FormGroup>
            </div>

            <div className="contestar-row">
              <FormGroup label={<>Motivo <span className="contestar-required">*</span></>} className="contestar-field-grow">
                <InputGroup
                  value={this.obs.contestacao.motivo}
                  onChange={(e: any) => this.obs.contestacao.motivo = e.target.value}
                />
              </FormGroup>
            </div>
          </div>

          <div className="contestar-footer">
            <div className="contestar-switches">
              <div style={{ display: "flex", alignItems: "center" }}>
                <label style={{ width: 140, marginBottom: 0 }}>
                  Salvar contestação
                  {this.obs.memoria_salvar  && <AppIcon
                    name="help"
                    className="pulse-notification-pgdas"
                    color="blue"
                    style={{ cursor: "pointer", marginLeft: 5 }}
                    onClick={(e) => ResultadoStore.obs.open_ajuda_salvar = true}
                  />}
                </label>
                <Switch
                  alignIndicator={Alignment.RIGHT}
                  innerLabelChecked="Sim"
                  innerLabel="Não"
                  checked={this.obs.memoria_salvar}
                  onChange={(e: any) => this.obs.memoria_salvar = e.target.checked}
                />
              </div>
              {this.obs.memoria_salvar && (
                <div style={{ display: "flex", alignItems: "center", paddingTop: 10 }}>
                  <label style={{ width: 140, marginBottom: 0 }}>
                    Memória CNPJ
                    <AppIcon
                      name="help"
                      className="pulse-notification-pgdas"
                      color="blue"
                      style={{ cursor: "pointer", marginLeft: 5 }}
                      onClick={() => this.obs.open_ajuda = true}
                    />
                  </label>
                  <Switch
                    alignIndicator={Alignment.RIGHT}
                    innerLabelChecked="Sim"
                    innerLabel="Não"
                    checked={this.obs.cnpj_memoria}
                    onChange={(e: any) => this.obs.cnpj_memoria = e.target.checked}
                  />
                </div>
              )}
            </div>

            <div className="contestar-actions">
              <Button text="Cancelar" onClick={() => this.props.onClose()} />
              <Button text="Contestar" intent="primary" onClick={this.handleConfirm} />
            </div>
          </div>
        </div>
      </Dialog>

      <InfoModal open={this.obs.open_ajuda} onClose={() => this.obs.open_ajuda = false} texto_info={`

        <b>Memória CNPJ:</b><br /><br />

        <b>Ativada</b> – O sistema valida o CNPJ de origem nas entradas e o CNPJ de destino nas saídas para salvar a Memória de Cálculo.<br /><br />

        <b>Desativada</b> – O sistema não realiza a validação de CNPJ, permitindo salvar a Memória de Cálculo sem informações de CNPJ.<br /><br />

      `} />
    </>);
  }
}
